import {ManyResponse} from '../../../responses/many.response';
import {SCondition, RequestQueryBuilder} from '@nestjsx/crud-request';
import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseUnit} from '../models';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchShelfLifeSpecsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public queryUnits(pageSize: number = 50,
                    currentPage: number = 0,
                    sortDirection: 'ASC' | 'DESC' | '' = 'ASC',
                    sortBy: string = 'shelfLifeDaysRemaining',
                    filters: SCondition | null): Observable<ManyResponse<BaseUnit>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/shelf-life-specs')
      .appendRawQueryString(qb.query(false))
      .get;

    return this.httpClient.get<ManyResponse<BaseUnit>>(endpoint);
  }

  public getDistinctStations(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/shelf-life-specs')
      .addSegment('/stations')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ LOCN: string }]>(endpoint).pipe(
      map(response => response.map(v => v.LOCN))
    );
  }

  public getDistinctDepartments(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/shelf-life-specs')
      .addSegment('/depts')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ DEPT: string }]>(endpoint).pipe(
      map(response => response.map(v => v.DEPT))
    );
  }

}
